import { Button, OverflowTooltipLabel } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { CopyProjectToastShell } from './CopyProjectToastShell';
import { useCopyProjectName } from './copy-project-registry';

interface CopyCompletedToastContentProps {
    projectID: string;
    onOpen: () => void;
}

export function CopyCompletedToastContent({
    projectID,
    onOpen,
}: CopyCompletedToastContentProps): ReactNode {
    const projectName = useCopyProjectName(projectID);
    return (
        <CopyProjectToastShell iconName="check_circle" title="Success">
            <div className="flex flex-row gap-2 align-items-baseline flex-wrap min-w-0 w-full">
                <span>Project copied successfully.</span>
                <Button
                    link
                    size="small"
                    onClick={onOpen}
                    className="flex min-w-0 max-w-full"
                >
                    {projectName ? (
                        <span className="flex align-items-baseline min-w-0 max-w-full">
                            <span className="flex-none white-space-nowrap">
                                Go to &quot;
                            </span>
                            <OverflowTooltipLabel
                                label={projectName}
                                tooltipMy="center bottom"
                                tooltipAt="center top"
                                className="flex-initial min-w-0 overflow-hidden text-overflow-ellipsis white-space-nowrap"
                            />
                            <span className="flex-none white-space-nowrap">
                                &quot; project →
                            </span>
                        </span>
                    ) : (
                        <span className="flex-none white-space-nowrap">
                            Go to project →
                        </span>
                    )}
                </Button>
            </div>
        </CopyProjectToastShell>
    );
}
